<template>
  <template v-if="Object.hasOwn(result, block.slug) && shopMaterials">
    <ProductMaterialRoundView
      v-if="!block.view_type || block.view_type === filterViewType.round"
      :title="block.currentTranslation.title"
      :selected-item="result[block.slug] as MaterialData"
      :block="block"
      :label-class="labelClass"
      @filter="onFilterClick"
    >
      <template v-if="!hideLearnMoreLink" #additional>
        <!-- <ProductMaterialLearnMoreLink
          v-if="
            block.sku === stoneTypeSku ||
            block.sku === propertiesGroupSkus.stoneType
          "
          :title="block.currentTranslation.title"
        /> -->
      </template>
    </ProductMaterialRoundView>
    <ProductMaterialTileView
      v-else-if="block.view_type === filterViewType.icon"
      :title="block.currentTranslation.title"
      :selected-item="result[block.slug] as MaterialData"
      :block="block"
      :label-class="labelClass"
      :is-regular-pdp="isRegularPdp"
      @filter="onFilterClick"
    >
      <template v-if="!hideLearnMoreLink" #additional>
        <ProductMaterialLearnMoreLink
          v-if="
            block.sku === stoneTypeSku ||
            block.sku === propertiesGroupSkus.stoneType
          "
          :title="block.currentTranslation.title"
        />
      </template>
    </ProductMaterialTileView>
    <ProductMaterialButtonView
      v-else-if="block.view_type === filterViewType.button"
      :title="block.currentTranslation.title"
      :selected-item="result[block.slug] as MaterialData"
      :block="block"
      :label-class="labelClass"
      @filter="onFilterClick"
    >
      <template v-if="!hideLearnMoreLink" #additional>
        <ProductMaterialLearnMoreLink
          v-if="
            block.sku === stoneTypeSku ||
            block.sku === propertiesGroupSkus.stoneType
          "
          :title="block.currentTranslation.title"
        />
      </template>
    </ProductMaterialButtonView>
    <ProductExpandedBlock
      v-else-if="block.view_type === filterViewType.button_big"
      :title="block.currentTranslation.title?.toUpperCase()"
      :selected-item="result[block.slug] as MaterialData"
    >
      <ProductMaterialBigButtonView
        :selected-item="result[block.slug] as MaterialData"
        :block="block"
        @filter="onFilterClick"
      ></ProductMaterialBigButtonView>
    </ProductExpandedBlock>

    <ProductMaterialCheckboxView
      v-else-if="block.view_type === filterViewType.checkbox"
      :title="block.currentTranslation.title"
      :selected-item="result[block.slug] as MaterialData"
      :block="block"
      :label-class="labelClass"
      @filter="onFilterClick"
    >
      <template v-if="!hideLearnMoreLink" #additional>
        <ProductMaterialLearnMoreLink
          v-if="
            block.sku === stoneTypeSku ||
            block.sku === propertiesGroupSkus.stoneType
          "
          :title="block.currentTranslation.title"
        />
      </template>
    </ProductMaterialCheckboxView>
    <ProductMaterialSelectView
      v-else-if="block.view_type === filterViewType.select"
      :title="block.currentTranslation.title"
      :selected-item="result[block.slug] as MaterialData"
      :block="block"
      :label-class="labelClass"
      @filter="onFilterClick"
    >
      <template v-if="!hideLearnMoreLink" #additional>
        <ProductMaterialLearnMoreLink
          v-if="
            block.sku === stoneTypeSku ||
            block.sku === propertiesGroupSkus.stoneType
          "
          :title="block.currentTranslation.title"
        />
      </template>
    </ProductMaterialSelectView>
  </template>
  <template
    v-else-if="Object.hasOwn(additionalOptions, block.slug) && shopMaterials"
  >
    <ProductMaterialRoundView
      v-if="!block.view_type || block.view_type === filterViewType.round"
      :title="block.currentTranslation.title"
      :selected-item="additionalOptions[block.slug] as MaterialData"
      :block="block"
      :label-class="labelClass"
      @filter="onOptionsFilterClick"
    >
      <template v-if="!hideLearnMoreLink" #additional>
        <ProductMaterialLearnMoreLink
          v-if="
            block.sku === stoneTypeSku ||
            block.sku === propertiesGroupSkus.stoneType
          "
          :title="block.currentTranslation.title"
        />
      </template>
    </ProductMaterialRoundView>
    <ProductMaterialTileView
      v-else-if="block.view_type === filterViewType.icon"
      :title="block.currentTranslation.title"
      :selected-item="additionalOptions[block.slug] as MaterialData"
      :block="block"
      :label-class="labelClass"
      :is-regular-pdp="isRegularPdp"
      @filter="onOptionsFilterClick"
    >
      <template v-if="!hideLearnMoreLink" #additional>
        <ProductMaterialLearnMoreLink
          v-if="
            block.sku === stoneTypeSku ||
            block.sku === propertiesGroupSkus.stoneType
          "
          :title="block.currentTranslation.title"
        />
      </template>
    </ProductMaterialTileView>
    <ProductMaterialButtonView
      v-else-if="block.view_type === filterViewType.button"
      :title="block.currentTranslation.title"
      :selected-item="additionalOptions[block.slug] as MaterialData"
      :block="block"
      :label-class="labelClass"
      @filter="onOptionsFilterClick"
    >
      <template v-if="!hideLearnMoreLink" #additional>
        <ProductMaterialLearnMoreLink
          v-if="
            block.sku === stoneTypeSku ||
            block.sku === propertiesGroupSkus.stoneType
          "
          :title="block.currentTranslation.title"
        />
      </template>
    </ProductMaterialButtonView>
    <ProductMaterialCheckboxView
      v-else-if="block.view_type === filterViewType.checkbox"
      :title="block.currentTranslation.title"
      :selected-item="additionalOptions[block.slug] as MaterialData"
      :block="block"
      :label-class="labelClass"
      @filter="onOptionsFilterClick"
    >
      <template v-if="!hideLearnMoreLink" #additional>
        <ProductMaterialLearnMoreLink
          v-if="
            block.sku === stoneTypeSku ||
            block.sku === propertiesGroupSkus.stoneType
          "
          :title="block.currentTranslation.title"
        />
      </template>
    </ProductMaterialCheckboxView>
    <ProductMaterialSelectView
      v-else-if="block.view_type === filterViewType.select"
      :title="block.currentTranslation.title"
      :selected-item="additionalOptions[block.slug] as MaterialData"
      :block="block"
      :label-class="labelClass"
      @filter="onOptionsFilterClick"
    >
      <template v-if="!hideLearnMoreLink" #additional>
        <ProductMaterialLearnMoreLink
          v-if="
            block.sku === stoneTypeSku ||
            block.sku === propertiesGroupSkus.stoneType
          "
          :title="block.currentTranslation.title"
        />
      </template>
    </ProductMaterialSelectView>
  </template>
</template>

<script setup lang="ts">
import { HTMLAttributes } from "vue";
import {
  FilteredMaterialsByCategoriesI,
  IProductConfigurationResult,
  IProductMaterialFilterEvent,
  MaterialData,
} from "ecom-types";
import { propertiesGroupSkus, sizesSlugs, stoneTypeSku } from "~/configs";

const props = defineProps<{
  block: FilteredMaterialsByCategoriesI;
  result: IProductConfigurationResult;
  additionalOptions: IProductConfigurationResult;
  labelClass?: HTMLAttributes["class"];
  hideLearnMoreLink?: boolean;
  showIfOnePropertyInList?: boolean;
  isRegularPdp?: boolean;
}>();

const emit = defineEmits<{
  (e: "optionsFilter", value: IProductMaterialFilterEvent): void;
  (e: "filter", value: IProductMaterialFilterEvent): void;
}>();

const SizeMaterialCategory = computed(() => {
  return sizesSlugs.includes(props.block.slug);
});

const shopMaterials = computed(() => {
  return (
    props.showIfOnePropertyInList ||
    props.block.materials?.length > 1 ||
    SizeMaterialCategory.value
  );
});

function onOptionsFilterClick(value: IProductMaterialFilterEvent) {
  emit("optionsFilter", value);
}

function onFilterClick(value: IProductMaterialFilterEvent) {
  emit("filter", value);
}
</script>
